import { render, staticRenderFns } from "./ToExpireProductsBlock.vue?vue&type=template&id=8cc12424&scoped=true&"
import script from "./ToExpireProductsBlock.vue?vue&type=script&lang=ts&"
export * from "./ToExpireProductsBlock.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8cc12424",
  null
  
)

export default component.exports